/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-page-custom-font */
import parse from "html-react-parser";
import { transformToHtml } from "../../utils/CommonUtils";
import { flightsInlineCSSMob } from "../../utils/stylesUtil/flightsInlinecssMob";
import { offersCss } from "../../utils/stylesUtil/offersCSS";
import { footerMobCss } from "../../utils/stylesUtil/footerMobCss";
import { ab } from "../../public/js/core/abMock";

export const appendHeadRoutePWA = (props) => {
  const {
    serviceWorker,
    lang,
    ccde,
    template,
    state,
    validBankOfferSize,
    jsSettingJson,
    initial_css: initialCSS,
    language,
    appConfig,
    currentTemplate,
    srcCoordinates,
    destCoordinates,
    tokenJson = {},
    isGoibibo = false,
    pageLoad = {},
  } = props || {};

  let cssPath;
  // let jsPath;
  // let imagePath;
  // let minExt;
  let robotMeta = "";
  let serverCssPath = "";
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    serverCssPath = "https://jsak.mmtcdn.com/flights/server";
    // jsPath = `${appConfig.jsPath}/js`;
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    if (template && template.robotic_tag) {
      if (!state?.Listing?.listingResponse) {
        robotMeta = '<meta name="robots" content="noindex, nofollow">';
      } else if (state?.Listing?.listingResponse) {
        robotMeta = '<meta name="robots" content="index, follow">';
      }
    } else {
      robotMeta = '<meta name="robots" content="index, follow">';
    }
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    serverCssPath = "http://localhost:8000/build/server";
    // jsPath = '/js';
    // imagePath = '/images';
    // minExt = '';
  }

  const flightInlineCss = flightsInlineCSSMob;
  const styleMobJSP = `
  @media screen and (max-device-width: 480px){
      .fli-intl-container {
      padding: 0px;
  }}

  .breadcrumb {
      padding: 8px 15px;
      margin-bottom: 20px;
      list-style: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #d8eaff;
      display: flex;
  }
  .breadcrumb>.active {
      color: #777;
  }
  .breadcrumb>li, .pagination {
      display: flex;
  }

  .breadcrumb a {
      color: #006dff;
      text-decoration: none;
      cursor: pointer;
  }
  .breadcrumb>li+li:before {
      padding: 0 5px;
      color: #ccc;
      content: "/\u00a0";
      font-size: 18px;
  }
  `;
  // const distanceCoordinates = currentTemplate === 'df_distance_template' && srcCoordinates && destCoordinates ? `<script>
  // var srcCoordinates = ${srcCoordinates};
  // var destCoordinates = ${destCoordinates};
  // </script>` : '';
  const bankOfferMobPath = `${cssPath}/bankOfferMob.min.css`;
  let windowLang = "window.lang =  'eng'";
  if (language === "ar") {
    windowLang = "window.lang =  'ara'";
  } else if (language === "hi") {
    windowLang = "window.lang =  'hin'";
  }
  const tokenJsonString =
    tokenJson && tokenJson?.length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)}`
      : 'var tokenJson = {"dest_city_name":"Mumbai","src_city_code":"DEL","dest_city_code":"BOM","src_city_name":"New Delhi"};';
  const scriptTransform = {
    transform: (node) => {
      if (node.type === "script") {
        return (
          <script defer src={node?.attribs?.src}>
            {node?.children[0]?.data}
          </script>
        );
      }
      return null;
    },
  };
  const serviceWorkerString = appConfig?.liveMode === true ? serviceWorker : "";
  //   <c:choose>
  // 	<c:when test="${appConfig.getLiveMode() == 'true'}">
  // 		<link href="${CSS_PATH }/flights/intentOfferOverlay.min.css?v=${appConfig.getResourceVersion()}" rel="stylesheet">
  // 		<script type="text/javascript" src="${jspath}/seo/assets/js/flights/intentOffer.min.js?v=${appConfig.getResourceVersion()}"></script>
  // 	</c:when>
  // 	<c:otherwise>
  // 		<link href="${CSS_PATH }/flights/intentOfferOverlay.css" rel="stylesheet">
  // 		<script type="text/javascript" src="${jspath}/seo/assets/js/flights/intentOffer.js?v=${appConfig.getResourceVersion()}"></script>
  // 	</c:otherwise>
  // </c:choose>
  const googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
  const googleTagSrc = `https://www.googletagmanager.com/ns.html?id=${googleTagId}`;
  return (
    <>
      {/* <script dangerouslySetInnerHTML={{ __html: scriptGoogleTag }} /> */}
      {parse(robotMeta)}
      <link href="https://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossOrigin />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link rel="preconnect" href="//fonts.googleapis.com" crossOrigin />
      <link rel="stylesheet" href={`${serverCssPath}${initialCSS}`} />
      {language === "ar" ? (
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700&display=swap"
          as="style"
          onload="this.onload=null;this.rel='stylesheet'"
        />
      ) : (
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Lato:300,400,500,400i,700,900&display=swap"
          as="style"
          onload="this.onload=null;this.rel='stylesheet'"
        />
      )}
      {/* <link rel="preload" as="image" href="//imgak.mmtcdn.com/flights/assets/media/pwa_flight_sprite.png" /> */}
      <style dangerouslySetInnerHTML={{ __html: flightInlineCss }} />
      <style dangerouslySetInnerHTML={{ __html: offersCss }} />
      <style dangerouslySetInnerHTML={{ __html: footerMobCss }} />
      <style type="text/css">{styleMobJSP}</style>
      {currentTemplate === "df_distance_template" && srcCoordinates && destCoordinates ? (
        <script>var srcCoordinates = srcCoordinates; var destCoordinates = destCoordinates;</script>
      ) : (
        <></>
      )}
      {ccde || ccde === "in" || ccde === "IN" ? (
        <noscript>
          <iframe
            title="routepwa"
            src={googleTagSrc}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
      ) : (
        <></>
      )}
      {tokenJson?.tokensList?.airline_code && tokenJson.tokensList.airline_code.length !== 0 ? (
        <script>var airlineCode = {tokenJson.tokensList.airline_code};</script>
      ) : (
        <></>
      )}
      <link href={`${bankOfferMobPath}`} rel="stylesheet" />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.pageLoad = ${JSON.stringify(pageLoad)};
                window.isSeoMain = true;
                var currentDateddMMyy = '${tokenJson?.tokensList?.cheap_ddMMyy || ""}';
                window.seoUrl = "${tokenJson?.tokensList?.url || ""}";
                window.currentTemplate = '${currentTemplate || ""}';
                window.seoScreenParams = {trip : 'oneWay',
                    classtype : 'E',
                    fromcityname : '${tokenJson?.tokensList?.src_city_name || ""}',
                    tocityname   : '${tokenJson?.tokensList?.dest_city_name || ""}',
                    fromcity : '${tokenJson?.tokensList?.src_city_code || ""}',
                    tocity   : '${tokenJson?.tokensList?.dest_city_code || ""}',
                    childcount : 0,
                    infantcount : 0,
                    adultcount : 1,
                    depdate : '${tokenJson?.tokensList?.cheap_MMddyyyy || ""}',
                    isIntl : false,
                    airlinecode : '${tokenJson?.tokensList?.airline_code || ""}'};
                window.AB=${JSON.stringify(ab)};
                window.urlParamsString = "?trip=oneWay&classtype=E&fromcity=${
                  tokenJson?.tokensList?.src_city_code
                }&tocity=${tokenJson?.tokensList?.dest_city_code}&fromcityname=${
            tokenJson?.tokensList?.src_city_name
          }&tocityname=${
            tokenJson?.tokensList?.dest_city_name
          }&childcount=0&adultcount=1&infantcount=0&depdate=${
            tokenJson?.tokensList?.cheap_MMddyyyy
          }&isIntl=false";
                window.urlParams = "?cabinClass=E&ccde=${ccde}&deviceMemory=8&intl=false&itinerary=${
            tokenJson?.tokensList?.src_city_code
          }-${tokenJson?.tokensList?.dest_city_code}-${
            tokenJson?.tokensList?.ddMMyyyy
          }&lang=${lang}&msv=2&paxType=A-1_C-0_I-0&ssr=true&tripType=O&pwa=true${isGoibibo ? "&cmpid=SEO": "&cmp=SEO"}";
                window.showOffer = false;
                window.jsSetting = ${JSON.stringify(jsSettingJson)};
                window.isPWA = true;
                window.isProduction = 'true';
                window.countryCode = '${ccde}';
                window.ccde = '${ccde}';
                window.validBankOfferSize = ${validBankOfferSize};
                ${windowLang};
                var jsSettingJson = ${JSON.stringify(jsSettingJson)};
                ${tokenJsonString}
                `,
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: `${serviceWorkerString}` }} />
    </>
  );
};
